import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HelperService } from '../../../services/helper.service';

import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';

import { ApiService } from '../../../services/api.service';

declare let $: any;
declare let bootbox: any;

@Component({
	selector: 'members-sendpwd-page',
	templateUrl: './sendpwd.html',
	styleUrls: ['./sendpwd.css']
})
export class MembersSendpwdPage {
	public modelName: string = 'member';
	public batchBtnStatus: boolean = true;
	public reloadTable: boolean = false;
	public searched: boolean = false;
	public sendPwdBtnStatus: boolean = true;
	public year: number = new Date().getFullYear();
	

	public constructor(
		private helper: HelperService,
		public formBuilder: FormBuilder,

		public data: DataService,

		private api: ApiService,
		private router: Router,
		private location: Location,
		private activatedRoute: ActivatedRoute
	) {}

	public ngOnInit() {
		if(!this.modelName) console.error('Missing modelName.');

		this.onBeforeRendered();

		
	}
	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

	}



	public onSendAllPwd(): void {
		this.sendPwdBtnStatus = false;
		if(!this.year){
			bootbox.alert({
				message: 'Please select fill in membership year',
				callback:() => {
					
				}
			});
			this.sendPwdBtnStatus = true;
			return;
		}
		
		try {
			let promise;
			promise = this.api.sendApiRequest('get', 'member/'+this.year+'/sendallpwd').toPromise();
			

			promise
			.then(res => {
				this.onAfterSendPwd(true);
				this.sendPwdBtnStatus = true;
			})
			.catch(err => {
				this.sendPwdBtnStatus = true;
			});
		}
		catch(e) {
			console.error(e);
				this.sendPwdBtnStatus = true;
		}
		
	}
	public onAfterSendPwd(success: boolean): void {
		if(success) {
			bootbox.alert({
				message: 'success sending password',
				callback:() => {
					
				}
			});
		}
	};
	

	
}



// WEBPACK FOOTER //
// ./src/pages/members/sendpwd/sendpwd.ts